import { useQuery } from '@tanstack/react-query';
import { getMe } from '../api/me';
import { ACCOUNT_SCOPE_QUERY_KEY } from '../configs/queryClient';
import { useAuth } from '../contexts/AuthContext';

// /me は Account スコープ。queryKeyHashFn が組織を前置しない key 先頭と一致させる
export const ME_QUERY_KEY = [ACCOUNT_SCOPE_QUERY_KEY] as const;

export function useMe() {
  const { user: firebaseUser, loading: authLoading } = useAuth();

  return useQuery({
    queryKey: ME_QUERY_KEY,
    queryFn: getMe,
    enabled: !authLoading && !!firebaseUser,
    staleTime: 60_000,
    refetchOnWindowFocus: false,
    retry: 0,
  });
}
